import styled from "styled-components";
import color from "../../../assets/css/colors";

export const Legend = styled.legend`
    font: normal normal normal 14px/20px Circular Std Book;
    color: #454546;
    margin-bottom: 20px;
`;

export const ErrorMessageInput = styled.span`
    position: absolute;
    color: ${color.red};
    bottom: 6px;
    left: 0;
    font-size: 12px;
`

export const ContainerInput = styled.div`
    position: relative;
`

export const ContainerForm = styled.div`
    width: 284px;

    @media (max-width: 600px){
        width: 100%;
    }
`

export const Button = styled.button`
    border: 0;
    outline: none;
    border-radius: 0;
    padding: 12px;
    margin-top: 42px;
    font-size: 1rem;
    width: 100%;
    font-weight: 600;
    border-radius: 12px;
    background: #F58B1E;
    color: #fff;
    transition: all.5s ease;
    
    -webkit-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
    -moz-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
    box-shadow: -4px 14px 50px -15px rgba(238, 168, 73, 1);
    
    
    &:hover {
        background: #ffa952;
    }
    
    &:focus {
        background: #ffa952;
        outline:none !important;
    }
    
    @media(max-width: 500px){
        width: 100%;
        margin-bottom: 40px;
    }
`;

export const ErrorMessage = styled.span`
    color: red;
`;